import AnnounceIcon from '@images/icons/announce-icon.svg?react'
import CheckMarkIcon from '@images/icons/check_mark_simple_icon.svg?react'
import './TrnStatusMessagePreview.scss'
import { CoreButton } from '@components'
import { useHeaderContext } from '@context/HeaderContext'
import cn from 'classnames'
import { paths, TransactionStatuses } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { useHistory } from 'react-router-dom'

interface IMessagePreviewProps {
  message?: any
  status?: string
  onConfirm?: () => void
  operation?: string
  enableWrapperStyles?: boolean
}

export const TrnStatusMessagePreview = ({
  message,
  status,
  onConfirm,
  operation = 'DEPOSIT',
  enableWrapperStyles = true
}: IMessagePreviewProps) => {
  const history = useHistory()

  const { setCurrentStep } = useHeaderContext()

  const success = status === TransactionStatuses.PROCESSED || status === TransactionStatuses.CONFIRMED
  const failed = status === TransactionStatuses.CANCELLED || status === TransactionStatuses.FAILED

  const capitalizeFirstLetter = (text: string): string => {
    if (text?.length) {
      const firstLetter = text[0].toLocaleUpperCase()
      return firstLetter + text.slice(1, text.length).toLocaleLowerCase()
    } else {
      return ''
    }
  }

  return (
    <div key={message} className={cn('message-preview-wrapper', { styled: enableWrapperStyles })}>
      <div className='message-preview'>
        <div className={cn('message-preview-icon', { success: success }, { failed: failed })}>
          {success ? <CheckMarkIcon /> : <AnnounceIcon />}
        </div>
        <div className='message-preview-content'>
          {success ? (
            <span className='message-preview-title'>
              {tr(`FRONTEND.${operation}.SUCCESSFUL_MESSAGE_TITLE`, `${capitalizeFirstLetter(operation)} successful`)}
            </span>
          ) : (
            <span className='message-preview-title'>
              {tr(
                `FRONTEND.${operation}.${status}_MESSAGE_TITLE`,
                `${capitalizeFirstLetter(operation)} ${capitalizeFirstLetter(status)}`
              )}
            </span>
          )}
          {success ? (
            <span className='message-preview-subtitle'>
              {tr('FRONTEND.DEPOSIT.SUCCESSFUL_MESSAGE_SUBTITLE', 'Go to  Transactions to view details.')}
            </span>
          ) : (
            <ErrorDisplay error={message} />
          )}
        </div>
        <CoreButton
          fullWidth
          size='large'
          variation='primary-black'
          onClick={() => {
            if (onConfirm) {
              onConfirm()
            } else {
              history.push(paths.dashboard())
              setCurrentStep(1)
            }
          }}
          text={tr('FRONTEND.PENDING_APPROVALS.ERROR_MODAL.OKAY', 'Okay')}
        />
      </div>
    </div>
  )
}
